import React from "react";

const Footer = () => (
  <footer>
    <div className="footer-inner" style={s.inner}>
      <span style={s.copy}>© 2026 Ramakrishna Katragadda</span>
      <span style={s.stoic}>"Do the work. Then let it go."</span>
      <span style={s.meta}>
        Bengaluru, IN ·{" "}
        <a
          href="https://github.com/ramakrishnakatragadda"
          target="_blank"
          rel="noreferrer"
          style={s.link}
        >
          GitHub
        </a>{" "}
        ·{" "}
        <a
          href="https://linkedin.com/in/ramakrishnakatragadda"
          target="_blank"
          rel="noreferrer"
          style={s.link}
        >
          LinkedIn
        </a>
      </span>
    </div>
  </footer>
);

const s = {
  inner: {
    borderTop: "1px solid var(--border)",
    maxWidth: 1100,
    margin: "0 auto",
    fontSize: "0.68rem",
    color: "var(--muted)",
    letterSpacing: "0.08em",
  },
  copy: {},
  stoic: {
    fontFamily: "var(--serif)",
    fontStyle: "italic",
    fontSize: "0.82rem",
    color: "var(--muted)",
  },
  meta: {},
  link: { color: "var(--muted2)", textDecoration: "none" },
};

export default Footer;
